import React, { useState, useContext, useEffect } from "react";
import { Icon, Label, Select, SelectOption, TabRoot, TabContent, Button, TabList, TabTrigger } from "@pmi/nyx-design-system";
import { ApiContext } from "../../context/apicontext";

// IQOS sidebar code
function IQOSsidebar({ isCloseSidebar }) {
    const { benchmarkData, IQOSData } = useContext(ApiContext);
    const [selectedValue, setSelectedValue] = useState("");
    const [selectedBtn, setSelectedBtn] = useState("Add");
    const [selectedTab, setSelectedTab] = useState("tab1");
    const [selectedClass, setSelectedClass] = useState("label_Add");
    const [showAllTabs, setShowAllTabs] = useState({
        tab1: false,
        tab2: false,
        tab3: false
    });

    const handleShowAll = (tabKey) => {
        setShowAllTabs({
            tab1: false,
            tab2: false,
            tab3: false,
            [tabKey]: true
        });
    };

    const handleOptions = (value) => {
        const selectedOption = benchmarkData?.ISQOptions?.find(option => option.value === value);
        if (selectedOption) {
            setSelectedValue(selectedOption.text);
        }
    };

    useEffect(() => {
        if (benchmarkData?.ISQOptions?.length > 0) {
            setSelectedValue(benchmarkData?.ISQOptions[0]?.text);
        }
    }, [benchmarkData]);

    const handleButtonClick = (option) => {
        setSelectedBtn(option);
        setSelectedTab(option === "Add" ? "tab1" : option === "Keep" ? "tab2" : "tab3");
        setSelectedClass(option === "Add" ? "label_Add" : option === "Keep" ? "label_Keep" : "label_Remove");
        setShowAllTabs({
            tab1: false,
            tab2: false,
            tab3: false
        });
    };

    const getCurrentData = () => {
        const key = selectedTab === "tab1" ? "Add" : selectedTab === "tab2" ? "Keep" : "Remove";
        return IQOSData.Assortment_Recommendations[key] || [];
    };

    const colorCode = {
        Medium: "#FFF5D6",
        Low: "#FFE0DA"
    };

    return (
        <>
            <div className="right-panel h-100">
                <div className="right-header" >
                    <div className="d-flex w-100 justify-content-between">
                        <div>
                            <Label size="small">IQOS Partner</Label>
                            <Label className="label">Shell #12345</Label>
                            <div><Icon color="dark" size='small' data-testid="icon-test" name="map-pin" /><Label style={{ textTransform: 'none' }} size="small">Herspicka 8,639 00 Brno-stred-Styrice,Czech Republic</Label></div>
                            <div><Icon color="dark" size='small' data-testid="icon-test" name="device-tablet" /><Label size="small">+420 543 234 894</Label></div>
                            <div><Icon color="dark" size='small' data-testid="icon-test" name="at" /><Label style={{ textTransform: 'none' }} size="small">xyz12345@shell.com</Label></div>
                        </div>
                        <Icon color="black" role="button" data-testid="icon-test" name="close" size="large" className="close-icon" onClick={() => { isCloseSidebar(false) }} />
                    </div>
                </div>

                <div className="right-panel-inner">
                    <div className="benchmark-column p-4 pe-3 pb-0 mb-2">
                        <div className="d-flex alim-align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div className="d-flex bg-lightgray p-1 rounded-3 me-1">
                                    <Icon color="dark" size='small' data-testid="icon-test" name="clipboard-list" />
                                </div>
                                <h6 className="small fw-bold">Benchmark column</h6>
                            </div>
                            <Select className="dropdown-box" starticon="download" endicon="chevron-down" placeholder={selectedValue} size="small" onChange={(value) => handleOptions(value)} >
                                {benchmarkData?.ISQOptions?.map((option, index) => (
                                    <SelectOption key={index} value={option.value}>
                                        {option.text}
                                    </SelectOption>
                                ))}
                            </Select>
                        </div>
                        <div className="divider-gray mt-4"></div>
                    </div>

                    <div className="p-4 pe-3">

                        {/* Performance Data */}
                        <Label className="label">Performance</Label>
                        <Label size="small" className="text-transform-none text-muted py-1"><Icon color="dark" className="m-1 mb-2" data-testid="icon-test" name="alert-circle" size="small" />Monthly average</Label>
                        <PerformanceSection data={IQOSData.Performance} title="CONSUMABLES" />
                        <PerformanceSection data={IQOSData.Consumables} title="KITS" />

                        {/* Assortment_Recommendations */}
                        <div className="accordion pe-3" id="demographicsAccordion2">
                            <div className="accordion-item">
                                <h2 className="accordion-header py-2" id="headingRight">
                                    <button className="accordion-button accordion_label" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse" >
                                        Assortment Recommendations
                                    </button>
                                </h2>
                                <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="headingRight" data-bs-parent="#demographicsAccordion2" >
                                    <div className="accordion-body">
                                        <TabRoot defaultValue={selectedTab}>
                                            <div className="tab-list bg-#F1F5F9">
                                                <div role="group" className="d-flex catchment-btn-wrapper rounded-2 p-1 w-full">
                                                    {["Add", "Keep", "Remove"].map((option) => (
                                                        <Button key={option} size="small" variant={selectedBtn === option ? "black" : "white"}
                                                            className={`${selectedBtn === option ? "active bg-white text-black border rounded-2 py-2" : "border-0 py-0 bg-transparent"} text-center`}
                                                            style={{ width: '150px' }}
                                                            onClick={() => handleButtonClick(option)} >
                                                            {option} ({IQOSData.Assortment_Recommendations[option]?.length})
                                                        </Button>
                                                    ))}
                                                </div>
                                            </div>

                                            {["Add", "Keep", "Remove"].map((option, index) => (
                                                <AssortmentSection key={index} tabKey={`tab${index + 1}`} title={option} buttonLabel={selectedBtn} buttonClass={selectedClass} showAll={showAllTabs[`tab${index + 1}`]}  handleShowAll={handleShowAll} data={Array.isArray(getCurrentData()) ? getCurrentData() : []}/>
                                            ))}
                                        </TabRoot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* leading_categories,Predictions, Proximity*/}
                        <TabSection title="Leading Categories" data={IQOSData.leading_categories} />
                        <TabSection title="Predictions" data={IQOSData.predictions} colorMapping={colorCode} />
                        <TabSection title="Proximity" data={IQOSData.proximity} />
                    </div>
                </div>
            </div>
        </>
    )
}
export default IQOSsidebar;

{/* Assortment_Recommendations */ }
const AssortmentSection = ({ tabKey, title, buttonLabel,buttonClass, showAll, handleShowAll, data }) => (
    <TabContent value={tabKey}>
        <table className="w-full border-collapse">
            <thead>
                <tr className="border-bottom">
                    <th className="p-2 text-left">#</th>
                    <th className="p-2 text-left w-100">SKU</th>
                    <th className="text-right">Recommendation</th>
                </tr>
            </thead>
            <tbody>
                {(data.slice(0, showAll ? data.length : 10)).map((item, index) => (
                    <tr key={index} className="border-bottom">
                        <td className="p-1">{index + 1}.</td>
                        <td className="p-1">{item.length > 18 ? item.substring(0, 18) + "..." : item}</td>
                        <td className="p-1 text-end">
                            <button className={`px-4 w-100 rounded ${buttonClass}`}>{buttonLabel}</button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        {data.length > 10 && !showAll && (
            <div className="text-center mt-2">
                <a className="text-blue-500 underline cursor-pointer hover:text-blue-700" role="button" onClick={() => handleShowAll(tabKey)}>
                    Show all (+{data.length - 10})
                </a>
            </div>
        )}
    </TabContent>
);

{/* CONSUMABLES, KITS */ }
const PerformanceSection = ({ data, title }) => {
    return (
        <TabRoot defaultValue="tab1">
            <Label className="py-3 fw-bold">{title}</Label>
            <TabContent value="tab1">
                <div className="d-flex justify-content-between py-2 border-bottom">
                    <Label className="w-25 text-transform-none fw-bold small">Indicator</Label>
                    <Label className="w-25 text-transform-none fw-bold small">Actual</Label>
                    <Label className="w-25 text-transform-none fw-bold small">Variance</Label>
                    <Label className="w-25 d-flex align-items-center fw-bold small">
                        <div className="d-flex bg-lightgray p-1 rounded-3 me-1">
                            <Icon color="dark" testId="icon-test" name="clipboard-list" size="small" />
                        </div>
                        Benchmark
                    </Label>
                </div>
                {data.map((row, index) => (
                    <div key={index} className="d-flex justify-content-between py-2 border-bottom">
                        <Label className="w-25 text-truncate">
                            {row.indicator.length > 10 ? row.indicator.substring(0, 10) + "..." : row.indicator}
                        </Label>
                        <span className={"w-25 text-center " + (row.actual === 'N/A' || row.actual === 'No data' ? "text-muted" : "")}>
                            {row.actual}
                        </span>
                        <span className={"w-25 rounded-3 text-center d-flex align-items-center justify-content-center " +
                            (row.variance === 'N/A' || row.variance === 'No data' ? "benchmark-na" : row.variance > 15 ? "benchmark-up" : "benchmark-down")} >
                            {row.variance !== 'N/A' && row.variance !== 'No data' && (
                                <Icon color={row.variance > 15 ? "#2D8121" : "#d23f32"} testId="icon-test"
                                    name={row.variance > 15 ? "arrow-up" : "arrow-down"} size="medium" className="me-1" />
                            )}
                            {row.variance}
                            {row.variance !== 'N/A' && row.variance !== 'No data' ? '%' : ''}
                        </span>
                        <span className={"w-25 text-center " + (row.benchmark === 'N/A' || row.benchmark === 'No data' ? "text-muted" : "")}>
                            {row.benchmark}
                            {row.benchmark !== 'N/A' && row.benchmark !== 'No data' ? '%' : ''}
                        </span>
                    </div>
                ))}
            </TabContent>
        </TabRoot>
    );
};

{/* Leading_categories, Predictions, Proximity */ }
const TabSection = ({ title, data, colorMapping }) => (
    <TabRoot defaultValue="tab1">
        <Label className="label py-3">{title}</Label>
        <TabContent value="tab1">
            {Object.entries(data).map(([key, value]) => (
                <div key={key} className="tab-data">
                    <Label className="text-transform-none">{key}</Label>
                    <span></span>
                    <span className="rounded-3 text-center" style={{ backgroundColor: colorMapping?.[value] || "transparent" }}>
                        {value}
                    </span>
                </div>
            ))}
        </TabContent>
    </TabRoot>
);